/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const eos_chain_about = () => `EOS is an open-source blockchain platform, founded on tech that prioritizes high performance, flexibility, security, and developer freedom. The EOS Network prioritizes usability across the ecosystem, so developers all can implement and grow their ideas.`
